export const CREW_MEMBER_SEARCH_TEXT = {
	inputLabel: 'Filter employees',
	inputPlaceholder: 'Name or number',
	inputId: 'text',
	closeAriaLabel: 'Close search',
};
